module.exports = __webpack_public_path__ + "img/exam-stat-status@1.5x.0eb156c6.png";